import { render, staticRenderFns } from "./abbreviationSimulation.vue?vue&type=template&id=3fc32038&scoped=true"
import script from "./abbreviationSimulation.vue?vue&type=script&lang=js"
export * from "./abbreviationSimulation.vue?vue&type=script&lang=js"
import style0 from "./abbreviationSimulation.vue?vue&type=style&index=0&id=3fc32038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc32038",
  null
  
)

export default component.exports